import { z } from "zod";

// §3.1 Domänen-Grundtypen ─────────────────────────────────────────────────────

/** user-facing Asset-Typen */
export const AssetKind = z.enum(["image", "animation", "spritesheet", "video", "audio"]);
export type AssetKind = z.infer<typeof AssetKind>;

/** interne Artefakt-Typen, getrennt von AssetKind (D42) */
export const ArtifactKind = z.enum(["video", "frames", "image", "audio", "spritesheet", "meta", "json"]);
export type ArtifactKind = z.infer<typeof ArtifactKind>;

/** API-only: nur 'server' (D45); 'client' entfällt */
export const Surface = z.literal("server");
export type Surface = z.infer<typeof Surface>;

export type ToolCategory = string;

// State-Machine (D18): queued → processing(generate) → processing(post-process) → done
// (D131-Historie: der Wartestatus `awaiting_trim` des manuellen Pflicht-Trims ist per D134
// ersatzlos entfallen — der PG-Enum-Wert aus Migr. 0028 bleibt physisch bestehen (PG droppt
// keine Enum-Werte), wird aber nie mehr gesetzt; hängende Jobs wurden beim Deploy bereinigt.)
export const JobStatus = z.enum(["queued", "processing", "done", "failed", "canceled"]);
export type JobStatus = z.infer<typeof JobStatus>;

export const JobPhase = z.enum(["generate", "post-process"]);
export type JobPhase = z.infer<typeof JobPhase>;

export const AssetRef = z.object({
  id: z.string(),
  kind: AssetKind,
  r2_key: z.string().nullable(),
});
export type AssetRef = z.infer<typeof AssetRef>;

export const CreditEstimate = z.object({
  credits: z.number().int(),
  breakdown: z.array(z.object({ label: z.string(), credits: z.number().int() })),
});
export type CreditEstimate = z.infer<typeof CreditEstimate>;

// Ledger-Domäne (§9.8) ────────────────────────────────────────────────────────
export const CreditSource = z.enum(["subscription", "package", "bonus"]);
export type CreditSource = z.infer<typeof CreditSource>;

/** Verbrauchsordnung-Tiebreaker bei gleichem Verfall (D8/D44): subscription < package < bonus */
export const SOURCE_RANK: Record<CreditSource, number> = {
  subscription: 0,
  package: 1,
  bonus: 2,
};

export const LedgerType = z.enum(["grant", "hold", "release", "settle", "refund", "expire", "reset", "adjust"]);
export type LedgerType = z.infer<typeof LedgerType>;

export const HoldStatus = z.enum(["active", "partial", "settled", "released", "expired"]);
export type HoldStatus = z.infer<typeof HoldStatus>;

export const AssetStatus = z.enum(["processing", "done", "failed"]); // KEIN 'skipped' (D42)
export type AssetStatus = z.infer<typeof AssetStatus>;

export const ArtifactStatus = z.enum(["pending", "processing", "done", "skipped", "failed"]);
export type ArtifactStatus = z.infer<typeof ArtifactStatus>;

export const TrashOrigin = z.enum(["user", "folder"]);
export type TrashOrigin = z.infer<typeof TrashOrigin>;
